import React from 'react';
import { NavLink } from 'react-router-dom';
import okapi_logo from '../../assets/images/okapi-peluche-p.jpg';
import NameSlogan from './NameSlogan/NameSlogan';
import NavigationItems from '../../components/Navigation/NavigationItems/NavigationItems';
import SocialShare from '../../components/SocialShare/SocialShare';

const header = props => {
  return (
    <header>
      <div className="flex justify-between font-serif bg-white mt-4 rounded-t-md">
        <div className='flex justify-start'>
          <NavLink to="/" exact><img src={okapi_logo} alt="Inicio"  width='100' height='100' className="ml-4" /></NavLink>
          <NameSlogan />
        </div>
        <SocialShare url={window.location.href} />
      </div>
      <nav className="flex items-center justify-between flex-wrap bg-green-dark p-4 lg:py-2" role="navigation" aria-label="Main menu">
        <NavigationItems />
      </nav>
    </header>
  );
}

export default header;
